<template>
    <el-card>
        <el-row class="game__title">Hotchat游戏配置管理</el-row>
        <!-- 搜索 -->
        <el-row class="game__search">
            <div class="item">
                <span>游戏类型:</span>
                <el-select v-model="searchList.gameType" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in gameTypeList" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>显示状态:</span>
                <el-select v-model="searchList.showStatus" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in statusList" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>是否有效:</span>
                <el-select v-model="searchList.valid" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in validList" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>游戏名称:</span>
                <el-input style="width: 200px;" v-model="searchList.gameName" placeholder="请输入游戏名称" clearable></el-input>
            </div>
            <div class="item">
                <span>游戏ID:</span>
                <el-input style="width: 200px;" v-model="searchList.gameId" placeholder="请输入游戏ID" clearable></el-input>
            </div>
            <!-- <div class="item">
                <span>渠道:</span>
                <el-select v-model="searchList.channel" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in channelList" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
            <el-button type="primary" @click="getGameList(1)">搜索</el-button>
            <el-button type="success" @click="() => {
                addDialogVisible = true
                addDialogType = 0
            }">添加</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="gameList">
                <el-table-column prop="id" label="ID" align="center" width="80">
                </el-table-column>
                <el-table-column prop="gameId" label="游戏ID" align="center" width="120">
                </el-table-column>
                <el-table-column prop="gameName" label="游戏名称" align="center" width="150">
                </el-table-column>
                <el-table-column prop="gameType" label="游戏类型" align="center" width="120">
                    <template slot-scope="scope">
                        {{gameTypeList.find(item => item.value == scope.row.gameType)?.name || ''}}
                    </template>
                </el-table-column>
                <el-table-column prop="gameIcon" label="游戏图标" align="center" width="120">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.gameIcon" style="width: 60px; height: 60px;"
                            :preview-src-list="[scope.row.gameIcon]" />
                    </template>
                </el-table-column>
                <el-table-column prop="gameDesc" label="游戏描述" align="center" width="200">
                </el-table-column>
                <el-table-column prop="gameLink" label="游戏链接" align="center" width="200">
                    <template slot-scope="scope">
                        <el-link :href="scope.row.gameLink" target="_blank" type="primary">{{scope.row.gameLink}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="halfGameLink" label="半屏链接" align="center" width="200">
                    <template slot-scope="scope">
                        <el-link :href="scope.row.halfGameLink" target="_blank" type="primary">{{scope.row.halfGameLink}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="gameNew" label="是否新游戏" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.gameNew == 0 ? 'info' : 'success'" size="small">
                            {{ scope.row.gameNew == 0 ? '否' : '是' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="gameCoinSwitch" label="游戏币开关" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.gameCoinSwitch == 0 ? 'danger' : 'success'" size="small">
                            {{ scope.row.gameCoinSwitch == 0 ? '关闭' : '开启' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="showStatus" label="显示状态" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.showStatus == 0 ? 'warning' : 'success'" size="small">
                            {{ scope.row.showStatus == 0 ? '隐藏' : '显示' }}
                        </el-tag>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="valid" label="是否有效" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.valid == 0 ? 'danger' : 'success'" size="small">
                            {{ scope.row.valid == 0 ? '无效' : '有效' }}
                        </el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column prop="sortId" sortable label="排序" align="center" width="80">
                </el-table-column>
                <!-- <el-table-column prop="channel" label="渠道" align="center" width="100">
                    <template slot-scope="scope">
                        {{channelList.find(item => item.value == scope.row.channel)?.name || scope.row.channel}}
                    </template>
                </el-table-column> -->
                <el-table-column prop="mtime" :formatter="formatTime" label="修改时间" align="center" width="150">
                </el-table-column>
                <el-table-column prop="ctime" :formatter="formatTime" label="创建时间" align="center" width="150">
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="updateDialog(scope.row)"
                            style="margin-bottom: 10px;">编辑</el-button>
                        <!-- <el-button type="danger" @click="deleteGame(scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit"
                @current-change="handleCurrentChange">
            </el-pagination>
        </el-row>
        <!-- 添加/编辑 -->
        <el-dialog :title="addDialogType == 0 ? '添加游戏' : '编辑游戏'" :visible.sync="addDialogVisible" width="60%"
            @close="addDialogClose">
            <el-form :model="addDialogInfo" :rules="ruleList" ref="addDialogForm" label-width="150px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="游戏ID" prop="gameId">
                            <el-input v-model="addDialogInfo.gameId" placeholder="请输入游戏ID"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="游戏整数ID" prop="gameIntId">
                            <el-input v-model="addDialogInfo.gameIntId" placeholder="请输入游戏整数ID"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="游戏名称" prop="gameName">
                            <el-input v-model="addDialogInfo.gameName" placeholder="请输入游戏名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="游戏类型" prop="gameType">
                            <el-select v-model="addDialogInfo.gameType" filterable placeholder="请选择">
                                <el-option v-for="(item, index) in gameTypeList" :key="index" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="游戏图标" prop="gameIcon">
                            <div style="display: flex; align-items: center;">
                                <UploadSingleImg v-model="addDialogInfo.gameIcon" :on-upload="uploadFile" style="margin-right: 10px;"></UploadSingleImg>
                                <el-input v-model="addDialogInfo.gameIcon" placeholder="或直接输入图标URL"></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="关联ID" prop="relatedId">
                            <el-input v-model="addDialogInfo.relatedId" placeholder="请输入关联ID"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="游戏链接" prop="gameLink">
                            <el-input v-model="addDialogInfo.gameLink" placeholder="请输入游戏链接"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="半屏链接" prop="halfGameLink">
                            <el-input v-model="addDialogInfo.halfGameLink" placeholder="请输入半屏链接"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="游戏描述" prop="gameDesc">
                            <el-input type="textarea" v-model="addDialogInfo.gameDesc" placeholder="请输入游戏描述"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="运营位参数" prop="operationParam">
                            <el-input v-model="addDialogInfo.operationParam" placeholder="请输入运营位参数" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <!-- <el-col :span="12">
                        <el-form-item label="排序ID" prop="sortId">
                            <el-input v-model="addDialogInfo.sortId" placeholder="请输入排序ID"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col :span="12">
                        <el-form-item label="渠道" prop="channel">
                            <el-select v-model="addDialogInfo.channel" filterable placeholder="请选择">
                                <el-option v-for="(item, index) in channelList" :key="index" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="12">
                        <el-form-item label="登录类型" prop="loginType">
                            <el-select v-model="addDialogInfo.loginType" filterable placeholder="请选择登录类型">
                                <el-option v-for="(item, index) in gameLoginTypeList" :key="index" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <!-- <el-col :span="8">
                        <el-form-item label="是否新游戏">
                            <el-switch v-model="addDialogInfo.gameNew" :active-value="1" :inactive-value="0" active-text="是"
                                inactive-text="否"></el-switch>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item label="游戏币开关">
                            <el-switch v-model="addDialogInfo.gameCoinSwitch" :active-value="1" :inactive-value="0" active-text="开启"
                                inactive-text="关闭"></el-switch>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-form-item label="显示状态">
                            <el-switch v-model="addDialogInfo.showStatus" :active-value="1" :inactive-value="0" active-text="显示"
                                inactive-text="隐藏"></el-switch>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="是否有效">
                            <el-switch v-model="addDialogInfo.valid" :active-value="1" :inactive-value="0" active-text="有效"
                                inactive-text="无效"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row style="text-align: right;">
                <el-button type="danger" @click="addDialogClose">取消</el-button>
                <el-button type="primary" @click="submitDialog">确定</el-button>
            </el-row>
        </el-dialog>
    </el-card>
</template>
<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg.vue'
import { getConstList } from '@/api/constRequest'

export default {
    name: 'GameConfig',
    components: {
        UploadSingleImg
    },
    data() {
        return {
            searchList: {
                gameType: null,
                showStatus: null,
                valid: 1,
                gameName: null,
                gameId: null,
                channel: 'cdd',
            },
            // 0:添加 1:编辑
            addDialogType: 0,
            addDialogVisible: false,
            statusList: [
                {
                    value: 0,
                    label: '隐藏'
                },
                {
                    value: 1,
                    label: '显示'
                }
            ],
            validList: [
                {
                    value: 0,
                    label: '无效'
                },
                {
                    value: 1,
                    label: '有效'
                }
            ],
            addDialogInfo: {
                gameId: null,
                gameIntId: null,
                gameName: null,
                gameType: null,
                gameIcon: '',
                relatedId: null,
                gameLink: null,
                halfGameLink: null,
                gameDesc: null,
                operationParam: null,
                sortId: 0,
                channel: 'cdd',
                loginType: null,
                gameNew: 0,
                gameCoinSwitch: 0,
                showStatus: 1,
                valid: 1,
            },
            ruleList: {
                'gameId': [{ required: true, message: '请输入游戏ID', trigger: 'blur' },],
                'gameIntId': [{ required: true, message: '请输入游戏整数ID', trigger: 'blur' },],
                'gameName': [{ required: true, message: '请输入游戏名称', trigger: 'blur' },],
                'gameType': [{ required: true, message: '请选择游戏类型', trigger: 'change' },],
                'gameIcon': [{ required: true, message: '请上传或输入游戏图标', trigger: 'blur' },],
                'gameLink': [{ required: true, message: '请输入游戏链接', trigger: 'blur' },],
                'halfGameLink': [{ required: true, message: '请输入半屏链接', trigger: 'blur' },],
                'gameDesc': [{ required: true, message: '请输入游戏描述', trigger: 'blur' },],
                'loginType': [{ required: true, message: '请选择登录类型', trigger: 'change' },],
            },
            gameTypeList: [],
            gameLoginTypeList: [],
            channelList: [],
            gameList: [],
            total: 0,
            page: 1,
            limit: 20,
        }
    },
    mounted() {
        this.getGameTypeList()
        this.getGameLoginTypeList()
        this.getChannelList()
        this.getGameList(1)
    },
    methods: {
        formatTime(row, column, cellValue) {
            return cellValue ? new Date(cellValue * 1000).toLocaleString() : ''
        },
        async uploadFile(file) {
            const formData = new FormData()
            formData.append('file', file)
            formData.append('cover', 0)
            formData.append('dir', 'game/icon')
            const { data: res } = await this.$axios.post(
                this.$store.getters.path.hostmgr_upload +
                '?username=' +
                this.$store.getters.username +
                '&token=' +
                this.$store.getters.token,
                formData
            )
            return { code: res.code, url: res.data }
        },
        async getGameTypeList() {
            const res = await getConstList('gameLoginType');
            if (res.code != 0) return this.$message.error(res.msg);
            this.gameTypeList = res.data
        },
        async getGameLoginTypeList() {
            const res = await getConstList('gameType');
            if (res.code != 0) return this.$message.error(res.msg);
            this.gameLoginTypeList = res.data
        },
        async getChannelList() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.channelList +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.channelList = [
                    { channelId: -1, name: 'all', value: 'all' },
                    ...res.data,
                ]
            }
        },
        addDialogClose() {
            this.addDialogVisible = false
            this.addDialogInfo = {
                gameId: null,
                gameIntId: null,
                gameName: null,
                gameType: null,
                gameIcon: '',
                relatedId: null,
                gameLink: null,
                halfGameLink: null,
                gameDesc: null,
                operationParam: null,
                sortId: 0,
                channel: 'cdd',
                loginType: null,
                gameNew: 0,
                gameCoinSwitch: 0,
                showStatus: 1,
                valid: 1,
            }
        },
        submitDialog() {
            this.$refs.addDialogForm.validate((valid) => {
                if (valid) {
                    if (this.addDialogType == 0) {
                        this.addGame()
                    } else {
                        this.updateGame()
                    }
                }
            });
        },
        updateDialog(info) {
            this.addDialogType = 1
            this.addDialogInfo = { ...info }
            this.addDialogVisible = true
        },
        handleCurrentChange(page) {
            this.getGameList(page)
        },
        async getGameList(page) {
            if (page) {
                this.page = page
            }
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_game_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: {
                    page: this.page,
                    pageSize: this.limit,
                    ...this.searchList
                }
            })
            if (res.code === 0 || res.status === 0) {
                console.log('API返回数据:', res.data)
                // 处理不同的数据结构
                if (Array.isArray(res.data)) {
                    this.gameList = res.data
                    this.total = res.data.length
                } else if (res.data && Array.isArray(res.data.data)) {
                    this.gameList = res.data.data
                    this.total = res.data.total || res.data.data.length
                } else if (res.data && typeof res.data === 'object') {
                    // 如果是对象，尝试解析为数组
                    try {
                        const parsedData = JSON.parse(res.data)
                        if (Array.isArray(parsedData)) {
                            this.gameList = parsedData
                            this.total = parsedData.length
                        } else {
                            this.gameList = []
                            this.total = 0
                        }
                    } catch (e) {
                        this.gameList = []
                        this.total = 0
                    }
                } else {
                    this.gameList = []
                    this.total = 0
                }
                console.log('处理后的游戏列表:', this.gameList)
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async addGame() {
            const data = JSON.parse(JSON.stringify(this.addDialogInfo))
            // 添加必要的字段
            data.username = this.$store.getters.username
            data.operator = this.$store.getters.username
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_game_add,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('添加成功，5分钟后生效')
                this.getGameList()
                this.addDialogClose()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async updateGame() {
            const data = JSON.parse(JSON.stringify(this.addDialogInfo))
            // 添加必要的字段
            data.username = this.$store.getters.username
            data.operator = this.$store.getters.username
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.config_game_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('更新成功，5分钟后生效')
                this.getGameList()
                this.addDialogClose()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async deleteGame(row) {
            this.$confirm('确定要删除这个游戏配置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.config_game_delete,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    },
                    data: {
                        id: row.id,
                        username: this.$store.getters.username
                    }
                })
                if (res.code === 0 || res.status === 0) {
                    this.$message.success('删除成功')
                    this.getGameList()
                } else {
                    this.$message.error(res.msg || res.message)
                }
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
    }
}
</script>
<style scoped lang="scss">
.game {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }
    }
}
</style>